<template>
     <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div class="blk1">
                       <img src="./image/banner1@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                       <div class="blkps">
                        <div class="blkrect"></div>
                        <div class="txtku1">我的资产</div>
                        <div class="txtku2">资产共计{{count}}个</div>
                       </div>
                    </div>
                    <div class="notice">
                        <div><img src="./image/search@2x.png" class="img1"></img></div>
                        <div class="txt1"><van-field class="field1" v-model="dInfo" placeholder="请输入设备相关信息" /></div>
                        <div>
                            <div class="search" @click="search">搜索</div>
                        </div>
                    </div>
                    <div v-if="m_item.length>0">
                        <div class="engSty" v-for="(item,index) in m_item" :key="index" @click="tDetail(item)">
                              <!-- <div class="tSty">{{item.assetsId}}-{{item.assetsUserName}}-{{item.assetsName}}</div> -->
							  <div class="tSty">{{item.assetsName}}</div>
                              <div class="subtSty">{{item.assetsCode}}</div>
                        </div>
                    </div>
                    <div v-else class="nData">暂无数据</div>
                </div>

            </div>
        </div>
     </div>


</template>
<script>
    import PJXQ from '@/components/pjxq.vue'
    export default{
        components:{PJXQ},
        data(){
            return {
                dInfo:'',
                m_item:[],
                count:0
            }
        },
        methods:{
            tDetail(item){
                // this.$router.push({path:'/propertyDetail',query: {code:item.assetsCode,tit:`${item.assetsCompanyId}-${item.assetsUserName}-${item.classification}`,id:item.assetsId}})
				this.$router.push({path:'/propertyDetail',query: {code:item.assetsCode,tit:`${item.assetsName}`,id:item.assetsId}})
            },
            getData(){
				if(this.$store.state.user.userInfo.role==1){
					let data={"assetsCompanyId":this.$store.state.user.userInfo.companyId};
					this.$api.post('/app/corporateassets/getCorAssetsList',data).then(res=>{
					       if(res.data.code=="0000"){
					            this.count=res.data.data.count;
								let data=res.data.data.datalist;
								let userId=this.$store.state.user.userInfo.userId
								let nArr=[]
								let fArr=[]
								data.forEach(item=>{
									if(item.assetsUserId==userId){
										nArr.push(item)
									}
								})
								data.forEach(item=>{
									if(item.assetsUserId!=userId){
										fArr.push(item)
									}
								})
								this.m_item=nArr.concat(fArr)
					       }
					    }
					)
				}else{
					let data={"assetsUserId":this.$store.state.user.userInfo.userId,"assetsCompanyId":this.$store.state.user.userInfo.companyId};
					this.$api.post('/app/corporateassets/getCorAssetsList',data).then(res=>{
					       if(res.data.code=="0000"){
					            this.count=res.data.data.count;
					            this.m_item=res.data.data.datalist;
					       }
					    }
					)
				}
            },
            getSearchData(dt){
				if(this.$store.state.user.userInfo.role==1){
					let data={assetsName:dt,"assetsCompanyId":this.$store.state.user.userInfo.companyId};
					this.$api.post('/app/corporateassets/getCorAssetsList',data).then(res=>{
					       if(res.data.code=="0000"){
					            this.m_item=res.data.data.datalist;
					       }
					    }
					)
				}else{
					let data={assetsName:dt,"assetsUserId":this.$store.state.user.userInfo.userId,"assetsCompanyId":this.$store.state.user.userInfo.companyId};
					this.$api.post('/app/corporateassets/getCorAssetsList',data).then(res=>{
					       if(res.data.code=="0000"){
					            this.m_item=res.data.data.datalist;
					       }
					    }
					)
				}
            },
            search(){
                this.getSearchData(this.dInfo)
            }
        },
        created(){
            this.getData()
        }
    }
</script>
<style scoped>
     .wrap{
            position: absolute;
            top: 0;
            left:0;
            width:100%;
            height:100%;
            z-index:1000;
            overflow: auto;
			overflow-x:hidden;
            background:#e9eef2;
        }
        .wrap_inner{
             min-height: 100%;
             width:100%;
        }
        .wrap_main{
            padding-bottom: 20px;
        }
    .mainlist{
        width:100%;
        height:340px;
    }
    .nData{
        width:100%;
        height:200px;
        display:flex;
        justify-content:center;
        align-items:center;
        font-size:14px;
    }
    .img1{
        width:25px;
        height:25px;
    }
    .blk1{
        position:relative;
        width: 100%;
        height: 148px;
    }
    .txt1{
        font-size:16px;
        margin-left:16px;
        color:#333
    }
    .field1{
        width:100%;
        height:35px;
        line-height:35px;
        padding:0;
    }
    .engSty{
        width: 309px;
        height: 40px;
        padding:18px 12px;
        margin:20px auto;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        font-size:12px;
    }
        .notice{
            display:flex;
            width: 90%px;
            height: 35px;
            padding:0 5%;
            margin:0px auto;
            background: #ffffff;
            border-radius: 4px;
            box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
            font-size:12px;
            align-items:center;
            justify-content:center;
        }
        .notice>div{
            flex:1;
        }
        .notice>div:nth-child(1){
            flex:0 0 19px;
        }
        .notice>div:nth-child(3){
            flex:0 0 22px;
        }
        .tSty{
            font-size: 20px;
            font-weight: 400;
            color: #333333;
        }
        .subtSty{
            margin-top:3px;
            font-size: 9px;
            font-weight: 400;
            color: #333333;
        }
        .search{
            width: 57px;
            height: 23px;
            background: linear-gradient(116deg,#36b3fe 11%, #0080ff 91%);
            border-radius: 12px;font-size:14px;color:#fff;text-align:center;
            line-height:23px;
        }
        .blkps{
            position:absolute;
            top:35px;
            right:52px;
            width:90px;
            height:90px;
        }
        .blkrect{
            width: 20px;
            height: 2px;
            background: #ffffff;
        }
        .txtku1{
            margin:4px 0 10px 0;
            font-size: 20px;
            font-weight: 800;
            text-align: left;
            color: #ffffff;
        }
        .txtku2{
            font-size: 16px;
            font-weight: 400;
            color: rgba(255,255,255,0.80);
        }
</style>
